// Должен соответствовать projectName
/* istanbul ignore next */
export const UNIQUE_CONFIG_KEY = 'request-form-realtor-frontend';
